import React from 'react'
import {NavLink} from 'react-router-dom';
import ServicesJson from '../../data/services/services.json'
//import ProductsJson from '../../data/products/products.json'

const NavBar = () => {
    return (
        <nav className="site-main-menu">
            <ul>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/about"}><span className="menu-text">About</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={`${process.env.PUBLIC_URL}/about`}><span className="menu-text">Our Team</span></NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}/gallery`}><span className="menu-text">Our Work</span></NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}/testimonials`}><span className="menu-text">Testimonials</span></NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}/financing`}><span className="menu-text">Financing</span></NavLink></li>
                    </ul>
                </li>
                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/services"}><span className="menu-text">Services</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        {ServicesJson.map(service => {
                        return <li key={service.link}><NavLink to={`${process.env.PUBLIC_URL}/${service.link}`}><span className="menu-text">{service.name}</span></NavLink></li>;
                        })}
                    </ul>
                </li>
                {/*<li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/types-of-insulation"}><span className="menu-text">Types of Insulation</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        {ProductsJson.map(product => {
                            return <li key={product.link}><NavLink to={`${process.env.PUBLIC_URL}/${product.link}`}><span className="menu-text">{product.name}</span></NavLink></li>;
                        })}
                    </ul>
                </li>*/}
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/service-areas"}><span className="menu-text">Service Areas</span></NavLink>
                </li>
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text">Contact</span></NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default NavBar
